export const hasAllReadings = (
  tabId: string,
  dirtyFields: Set<string>,
  registerCount: number,
): boolean => {
  const tabDirties = Array.from(dirtyFields).filter((path) => {
    const re = new RegExp(`^${tabId}.readings`, "i");
    return re.test(path);
  });

  return tabDirties.length === registerCount;
};
